// extracted by mini-css-extract-plugin
export default {"loading-overlay":"App_loading-overlay__cjc4J","overlay":"App_overlay__tW0eT"};